export const formatDatetimeToDatetimeFull = (date: Date | string): string =>
  formatDatetime(date, "dd/MM/yy h:mm a");
